/*
 * RŌGMA IA Scan — MediaPipe module bridge for Shopify.
 *
 * Cárgalo con:
 * <script type="module" src="{{ 'rogma-mediapipe-loader.js' | asset_url }}"></script>
 *
 * Este archivo vive como asset de Shopify y expone el módulo ESM a
 * rogma-scan.js mediante window.__ROGMA_MEDIAPIPE_VISION__.
 */

(() => {
  'use strict';

  const root = document.getElementById('rogma-scan-root');

  if (!root || root.dataset.faceGuidance === 'false') {
    return;
  }

  const candidates = Array.from(
    new Set(
      [
        root.dataset.mediapipeModuleUrl,
        'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.35/vision_bundle.mjs',
        'https://unpkg.com/@mediapipe/tasks-vision@0.10.35/vision_bundle.mjs?module',
      ].filter(Boolean)
    )
  );

  const normalizeVision = (moduleNamespace) => {
    const options = [
      moduleNamespace,
      moduleNamespace?.default,
      moduleNamespace?.vision,
    ];

    return (
      options.find(
        (candidate) =>
          candidate?.FilesetResolver &&
          candidate?.FaceLandmarker
      ) || null
    );
  };

  const errors = [];

  const load = async () => {
    for (const url of candidates) {
      try {
        const moduleNamespace = await import(url);
        const vision = normalizeVision(moduleNamespace);

        if (!vision) {
          throw new Error(
            'El módulo no expuso FilesetResolver y FaceLandmarker.'
          );
        }

        window.__ROGMA_MEDIAPIPE_VISION__ = vision;
        window.__ROGMA_MEDIAPIPE_SOURCE__ = url;
        root.setAttribute('data-face-module-bridge', 'ready');

        window.dispatchEvent(
          new CustomEvent('rogma:mediapipe-ready', {
            detail: { source: url },
          })
        );

        return;
      } catch (error) {
        errors.push(
          `${url} → ${
            error?.message || String(error)
          }`
        );
      }
    }

    const message =
      'No se pudo cargar MediaPipe desde los CDNs: ' +
      errors.join(' | ');

    window.__ROGMA_MEDIAPIPE_ERROR__ = message;
    root.setAttribute('data-face-module-bridge', 'failed');
    root.setAttribute(
      'data-face-module-bridge-error',
      message.slice(0, 500)
    );

    window.dispatchEvent(
      new CustomEvent('rogma:mediapipe-error', {
        detail: { message },
      })
    );

    console.error('[RŌGMA Face Module]', message);
  };

  load();
})();
